import { streamAgentMessage } from "./agentStreamService";
import {
  createAgentRunnerSession,
  pingAgentRunnerSession,
} from "./agentRunnerClient";
import type { AgentSseHandlers } from "../../utils/parseAgentSseStream";
import type { AgentChatResponse } from "../../types/agentChat";
import { agentApiBase } from "../../utils/agentApiBase";

const AGENT_ID = "production-support";

export type ProductionSupportChatResponse = AgentChatResponse;

export async function createProductionSupportSession(): Promise<string> {
  return createAgentRunnerSession(AGENT_ID);
}

export async function pingProductionSupportSession(
  sessionId: string,
): Promise<boolean> {
  return pingAgentRunnerSession(AGENT_ID, sessionId);
}

export async function streamProductionSupportMessage(
  sessionId: string,
  message: string,
  handlers: AgentSseHandlers = {},
): Promise<ProductionSupportChatResponse> {
  const base = await agentApiBase(AGENT_ID);
  return streamAgentMessage(
    base,
    sessionId,
    message,
    handlers,
    "Production support agent error",
  );
}
